import Axios from 'axios'

import { SERVER_BASE_URL } from '../baseUrl'

export const getAllVisiteurs = async (token: string, userEmail: string) => {
  try {
    const response = await Axios.get(
      `${SERVER_BASE_URL}api/profileVisiteur/visiteurs?userEmail=${userEmail}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
